module.exports = __webpack_public_path__ + "img/403.svg";